import { v3 } from '@adobe/edex/frontend/api/v3';

const baseURL = '/files';

export function list(id) {
  return v3.get(`${baseURL}?filterBy=entityID:${id}`);
}

export function get(id) {
  return v3.get(`${baseURL}/${id}`);
}

export function create(data) {
  return v3.post(`${baseURL}`, data);
}

export function update(id, data: { status: string; entityID?: string }) {
  return v3.put(`${baseURL}/${id}`, data);
}

export function remove(id) {
  return v3.delete(`${baseURL}/${id}`);
}
